import React, {useState} from 'react'
import {Card, Row, Col, Button, Modal} from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';
import LazyLoad from 'react-lazyload';

const endpoint = "https://files-website-fablab.s3.amazonaws.com/svg/machines/"
const endpointVideo = "https://files-website-fablab.s3.amazonaws.com/machines/"

export const ModalMachines = ({name, img, title, data, video}) => {

	const [show, setShow] = useState(false);
	const pathVideo = endpointVideo + video	

	const handleClose = () => {
		setShow(false);
		
	};

	const handleClick = () => {
		setShow(true)
	}

    return (
      <>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col className="text-center">
                <video src={pathVideo} width="90%" height="100%" controls rel="preload" autoPlay="autoplay" loop="loop" muted playsInline/>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                {ReactHtmlParser(data)} 
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button className="fablab-button" onClick={handleClose}>
            Cerrar
            </Button>
          </Modal.Footer>
        </Modal>

        <Card id="MachinesCard" className="text-center">
          <Card.Body>
            <LazyLoad height={200} offset={100}>
              <img alt="" src={endpoint+img} className="svgMachine"></img>
            </LazyLoad>
            <h3 className="textoMachines">{name}</h3>
            {title?<Button className="fablab-button" onClick ={handleClick}>Más información</Button>:<></>}
          </Card.Body>				
        </Card>
      </>
    )
}
